import { mapCheckboxValueToList } from "shared/helpers/mappers";
import { IConverter } from "shared/services/api/types";

import { ISelfTapeRequestNotificationFilterParams } from "models/selfTapeRequest";

import {
  DEFAULT_PAGE_NUMBER,
  FilterType,
  IFilterModel,
} from "./withSelfTapeRequestNotificationsFilter.config";

export class FilterModelToSelfTapeRequestNotificationFilterParamsConverter
  implements IConverter<IFilterModel, ISelfTapeRequestNotificationFilterParams>
{
  public convert(
    filterModel: IFilterModel
  ): ISelfTapeRequestNotificationFilterParams {
    const dateReceived = filterModel[FilterType.DateReceived] ?? [];

    return {
      pageIndex:
        (filterModel[FilterType.PageNumber] ?? DEFAULT_PAGE_NUMBER) - 1,
      dateSentFrom: dateReceived[0]?.toISOString(),
      dateSentTo: dateReceived[1]?.toISOString(),
      performerIds:
        filterModel[FilterType.Client] &&
        mapCheckboxValueToList(filterModel[FilterType.Client]!, {
          keepString: true,
        }),
      mediaRequestType:
        filterModel[FilterType.MediaRequestType] &&
        mapCheckboxValueToList(filterModel[FilterType.MediaRequestType]!, {
          keepString: true,
        }),
    };
  }
}
